import React from 'react'
import Preloader from '../component/Preloder/preloader';
import HomeSecOne from '../section/HomeSecOne/homeSecOne';
import SectionTwo from '../section/HomeSecTwo/secTwo';
import HomeSecThree from '../section/HomeSecTh/homeSecTh';
import HomeSecFour from '../section/HomeSecFour/homeSecFour';
import HomeAbout from '../section/HomeAbout';
import LikeSec from '../section/LikeSec';
import Stars from '../component/Stars';
import HomePhotoSec from '../section/HomePhotoSec/homePhotoSec';
import HomeDesignSec from '../section/HomeDesignSec/homeDesignSec';





function Home() {
  return (
    <div className='home-con'>
      {<Preloader/>}
      {<HomeSecOne/>}
      {<HomeAbout/>}
      {<SectionTwo/>}
      {<HomeSecThree/>}
      {<HomePhotoSec/>}
      {<HomeDesignSec/>}
      {<LikeSec/>}
      {<HomeSecFour/>}
      {<Stars/>}
    </div>
  )
}

export default Home;